<template>
    <div class="wrap-news">
        <header-app></header-app>
        <div class="news-banner"></div>
        <div class="news-details">
            <ul>
                <li class="news-item" v-for="(item,index) in newsList" :key="index">
                    <router-link :to="{path:'/news/details',query:{id:item.id}}">
                        <img :src="item.cover">
                        <div class="news-info">{{item.title}}</div>
                    </router-link>
                </li>
            </ul>
            <bottom-app></bottom-app>
            <top-scroll></top-scroll>
        </div>

    </div>
</template>

<script>
    import headerApp from '@/components/headerApp.vue'
    import bottomApp from '@/components/bottomApp.vue'
    import topScroll from '@/components/topScroll.vue'
    export default {
        components: {
            headerApp,
            bottomApp,
            topScroll
        },
        data(){
            return{
                newsList:[]
            }
        },
        created(){
            this.$api.newsList().then((res)=>{
                if(res){
                    this.newsList = res.list || []
                }
            })
        }
    }
</script>

<style lang="less" rel="stylesheet/less">
    .wrap-news{
        text-align: left;
        position: relative;
        .news-banner{
            height: 3rem;
            background: url("../../assets/imgs/tp-news-bg.png") no-repeat top center;
            background-size:cover;
            position: relative;
        }
        .news-details{
            position: absolute;
            left: 0;
            top: 2rem;
            padding: 0 .5rem;
            width: 100%;
            box-sizing: border-box;
        }
        .news-details{
            font-size: 0;
            line-height: 0;
            .news-item{
                height: 3.8rem;
                width: 48%;
                vertical-align: top;
                display: inline-block;
                margin-right: .2rem;
                &:nth-child(2n){
                    margin-right: 0;
                }
                img{
                    width: 100%;
                    height: 1.8rem;
                }
                .news-info{
                    color: #595757;
                    font-size: .24rem;
                    padding: .2rem 0;
                    line-height: .4rem;
                    font-weight: 700;
                }
            }
        }
    }
</style>
